enum BranchStatus {
    requested = 1,
    approved = 2,
    repproved = 3,
}

export default BranchStatus;
